// extracted by mini-css-extract-plugin
module.exports = {"main":"Interval_main__2TlYF","container":"Interval_container__2xz8x","one":"Interval_one__18eaI","title":"Interval_title__1uTLc","btn_div":"Interval_btn_div__3mKJ2"};